import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordChallengeComponent } from 'src/app/auth/change-password-challenge/change-password-challenge.component';

@Component({
  selector: 'esc-confirm-action',
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.scss']
})
export class ConfirmActionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordChallengeComponent>,
  ) { }

  ngOnInit() {
  }

}
